import React from "react";
import { I18n } from "react-redux-i18n";

interface IProps {
  size?: number;
  width?: number;
  height?: number;
  title?: string;
}

export const CarteBancaire: React.FC<IProps> = ({ width, height, title }) => {
  // required, otherwise, re-usage of this SVG component would result in the missing colors that are set based on the gradients id
  const uniqueId = Math.random().toString(36).substr(2, 6);

  return <svg
    viewBox="0 0 26.47 18.16"
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    style={{
      borderRadius: 3
    }}
  >
    <title>{title || I18n.t("hoverIcons.creditCardIcon")}</title>
    <defs>
      <radialGradient id={`gradient-b-${uniqueId}`} cx="1.47" cy="18.27" gradientTransform="matrix(1 0 0 .94 0 .5)"
                      gradientUnits="userSpaceOnUse" r="26.83">
        <stop offset=".09" stopColor="#009245"/>
        <stop offset=".23" stopColor="#049552" stopOpacity=".89"/>
        <stop offset=".52" stopColor="#0d9e74" stopOpacity=".59"/>
        <stop offset=".91" stopColor="#1bacab" stopOpacity=".12"/>
        <stop offset="1" stopColor="#1fb0b8" stopOpacity="0"/>
      </radialGradient>
      <radialGradient id={`gradient-c-${uniqueId}`} cx="5.89" cy="19.23" gradientUnits="userSpaceOnUse" r="34.42">
        <stop offset=".15" stopColor="#1fb0b8" stopOpacity="0"/>
        <stop offset=".35" stopColor="#1c7491" stopOpacity=".4"/>
        <stop offset=".56" stopColor="#1a4471" stopOpacity=".73"/>
        <stop offset=".74" stopColor="#18265e" stopOpacity=".93"/>
        <stop offset=".87" stopColor="#181b57"/>
      </radialGradient>
    </defs>
      <g>
        <path d="M0 0h26.47v18.16H0z" fill="#29abe2"/>
        <path d="M0 0h26.47v18.16H0z" fill={`url(#gradient-b-${uniqueId})`}/>
        <path d="M0 0h26.47v18.16H0z" fill={`url(#gradient-c-${uniqueId})`}/>
      </g>
      <g fill="#fff">
        <path
          d="M14.39 3.86h7.07a2.47 2.47 0 0 1 2.47 2.47 2.47 2.47 0 0 1-2.47 2.47h-7.07V3.86zM14.39 9.36h7.07a2.47 2.47 0 0 1 2.47 2.47 2.47 2.47 0 0 1-2.47 2.47h-7.07V9.36zM8.23 9.36V8.8h5.69a5.51 5.51 0 0 0-5.69-4.94 5.47 5.47 0 0 0-5.69 5.22 5.47 5.47 0 0 0 5.69 5.22 5.51 5.51 0 0 0 5.69-4.94z"/>
      </g>
  </svg>
};
